var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Tsttest")]),_c('th',[_vm._v("Tstdate")]),_c('th',[_vm._v("Tstsize")]),_c('th',[_vm._v("Tstres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }